import { type Injector } from '@angular/core';
import { BaseWidget } from '@sds/widget-gridster';

export class OwnConsumptionMonthWidget extends BaseWidget<{ plantId: string; title: string }> {
  static readonly id = 'monthly-own-consumption';
  static readonly publicFriendly = false;

  static factory(
    injector: Injector,
    metaLinkId: string,
    x: number,
    y: number,
    rows: number,
    cols: number,
    data: { plantId: string; title: string }
  ) {
    return new OwnConsumptionMonthWidget(injector, metaLinkId, x, y, rows, cols, data);
  }

  constructor(
    injector: Injector,
    metaLinkId: string,
    x: number,
    y: number,
    rows: number,
    cols: number,
    data: { plantId: string; title: string }
  ) {
    super(
      injector,
      OwnConsumptionMonthWidget.id,
      OwnConsumptionMonthWidget.publicFriendly,
      metaLinkId,
      x,
      y,
      rows,
      cols,
      data
    );
    this.resolveComponent(async () => {
      const module = await import('../month/own-consumption-month.component');
      return Object.values(module)[0];
    });
  }

  override resolveData(data: { plantId: string; title: string }): void {
    this.setData({ plantId: data.plantId, title: data.title });
  }
}
